import { Person } from "../types/person";
import { PersonAssociatedVersion } from "../types/version";
import BaseEntityService from "./baseEntityService";

const serviceUrlSuffix = "v1/persons";

export interface PersonAssociatedVersionsParams {
  personalRole?: string;
  teamRole?: string;
  language?: string;
}

class PersonService extends BaseEntityService<Person> {
  constructor() {
    super(serviceUrlSuffix);
  }

  async fetchVersions(
    personId: string,
    offset: number = 0,
    limit: number = 100,
    sort: string = "",
    params: {
      personalRole?: string;
      teamRole?: string;
      language?: string;
    }
  ): Promise<{
    data: PersonAssociatedVersion[];
    total: number;
  }> {
    const { personalRole, teamRole, language } = params;
    const queryParams = {
      offset: String(offset),
      limit: String(limit),
      ...(sort && { sort }),
    };
    const queryString = new URLSearchParams(queryParams).toString();
    const response = await this.httpClient.post(
      `${this.serviceUrlSuffix}/${personId}/versions?${queryString}`,
      {
        personal_role: personalRole,
        team_role: teamRole,
        language,
      }
    );
    return { data: response.data.data, total: response.data.metadata.total };
  }
}

export const personService = new PersonService();
